import { render, staticRenderFns } from "./uiButton.vue?vue&type=template&id=9e85d210&scoped=true"
import script from "./uiButton.vue?vue&type=script&lang=js"
export * from "./uiButton.vue?vue&type=script&lang=js"
import style0 from "./uiButton.vue?vue&type=style&index=0&id=9e85d210&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e85d210",
  null
  
)

export default component.exports